import Logo from '../../../../kikusuiロゴ.png';
import Clock from '../clock/Clock';
import { Const } from '../../../constants/Constants';
import { Button, Layout, Space, Switch } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

interface Iprops {
  screenName: string;
  showLogout?: boolean;
  changeDisplay?: boolean;
  changeDisplayFunction?: () => void;
}

const HeaderAntDesign = ({
  screenName,
  showLogout,
  changeDisplay,
  changeDisplayFunction,
}: Iprops) => {
  const { Header } = Layout;
  //  const history = useHistory();

  const handleLogout = () => {
    sessionStorage.removeItem(Const.LOCAL_STORAGE_VALUE.JWT);
    window.location.href = '/login';
    //    history.push('/login');
  };

  return (
    <Header
      style={{
        background: '#1d39c4',
        color: '#fff',
        fontSize: 20,
        position: 'sticky',
        top: 0,
        maxHeight: '50px',
        zIndex: 1,
        width: '100%',
      }}
    >
      <Space align="center">
        <img
          alt="ロゴ"
          src={Logo}
          style={{ height: '35px', marginBottom: '15px', width: 'auto' }}
        />
        　{screenName}
      </Space>
      {changeDisplay === true && (
        <Space style={{ position: 'absolute', left: 350 }}>
          <Switch
            checkedChildren="表示"
            unCheckedChildren="非表示"
            defaultChecked
            onClick={changeDisplayFunction}
          />
        </Space>
      )}
      <Space style={{ position: 'absolute', right: 50 }}>
        <Clock />
        {showLogout === true && (
          <Button size={'large'} style={{ color: 'white' }} type="link" onClick={handleLogout}>
            <LogoutOutlined />
            ログアウト
          </Button>
        )}
      </Space>
    </Header>
  );
};

export default HeaderAntDesign;
